var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.375V9.29167C10.8334 8.71703 10.6051 8.16593 10.1988 7.7596C9.79248 7.35327 9.24138 7.125 8.66675 7.125H4.33341C3.75878 7.125 3.20768 7.35327 2.80135 7.7596C2.39502 8.16593 2.16675 8.71703 2.16675 9.29167V10.375",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50004 5.95833C7.69666 5.95833 8.66671 4.98828 8.66671 3.79167C8.66671 2.59505 7.69666 1.625 6.50004 1.625C5.30342 1.625 4.33337 2.59505 4.33337 3.79167C4.33337 4.98828 5.30342 5.95833 6.50004 5.95833Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGray);
export default __webpack_public_path__ + "static/media/gray.34dcf0d7.svg";
export { ForwardRef as ReactComponent };